<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Вход</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" validation>
              <v-text-field
                  prepend-icon="person"
                  name="phone"
                  label="Телефон"
                  type="text"
                  v-model="phone"
                  :rules="phoneRules"
                  mask="+7 (###) ###-##-##"
                  validate-on-blur
                  outline
              ></v-text-field>
              <v-text-field
                  prepend-icon="lock"
                  name="password"
                  label="Пароль"
                  type="password"
                  v-model="password"
                  :rules="passwordRules"
                  validate-on-blur
                  outline
              ></v-text-field>
            </v-form>
            <div>
              <v-btn
                  flat
                  small
                  to="/password-recovery"
                  class="ml-4 forgot-pass-btn"
              >Забыли пароль?</v-btn>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="onSubmit"
                :loading="loading"
                :disabled="!valid || loading"
            >Войти</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        phone: '+7',
        password: '',
        valid: false,
        phoneRules: [
          v => !!v || 'Обязательное поле',
          v => /^[0-9+]{11,12}$/u.test(v) || 'Телефон не корректный'
        ],
        passwordRules: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length >= 0) || ''
        ]
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      onSubmit () {
        if (this.$refs.form.validate()) {
          const user = {
            phone: this.phone,
            password: this.password
          }

          this.$store.dispatch('loginUser', user)
        }
      }
    },
    created () {
      this.$store.commit('setPageTitle', 'Авторизация')
      if (this.$route.query['loginError']) {
        this.$store.dispatch('setError', 'Требуется авторизация')
      }
      let vm = this
      document.addEventListener('keyup', function (event) {
        if (event.key === 'Enter') {
          if (vm.valid && !vm.loading) {
            vm.onSubmit()
          }
        }
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Auth/Login.vue